import { Color, Flex, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { SIDE_NAVBAR_WIDTH } from '../../constants/sideNavbarWidth'

interface AppButtonWrapperProps {
  isClickable?: boolean
  backgroundColor: Color
  buttonColor?: Color
  hoverButtonColor?: Color
  hoverBackgroundColor?: Color
  hoverIconColor?: Color
  labelColor?: Color
  onClick?: () => void
}

export const AppButtonWrapper = styled(Flex)<AppButtonWrapperProps>`
  align-items: center;
  justify-content: center;
  width: ${SIDE_NAVBAR_WIDTH};
  height: ${SIDE_NAVBAR_WIDTH};

  ${({ isClickable, backgroundColor, hoverBackgroundColor, buttonColor }) => {
    return css`
      background-color: ${backgroundColor};
      cursor: ${isClickable ? 'pointer' : 'default'};
      &:hover {
        background-color: ${hoverBackgroundColor};
      }

      /* A "frame" around the "Ageras" button */
      ${!isClickable &&
      css`
        &:after {
          content: '';
          width: 36px;
          height: 36px;
          border: 3px solid ${buttonColor};
          border-radius: ${Spacing.S8};
          position: absolute;
          top: auto;
          left: auto;
          background-color: transparent;
        }
      `}
    `
  }};

  &:hover {
    ${() => AppButton} {
      background-color: ${({ isClickable, buttonColor, hoverButtonColor }) => {
        return isClickable ? hoverButtonColor : buttonColor
      }};

      path,
      rect {
        fill: ${({ hoverIconColor }) => hoverIconColor};
      }
    }
  }
`

type AppButtonProps = Omit<AppButtonWrapperProps, 'backgroundColor'>

export const AppButton = styled(Flex)<AppButtonProps>`
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: ${Spacing.S4};

  &:hover {
    background-color: ${({ isClickable, buttonColor, hoverButtonColor }) => {
      return isClickable ? hoverButtonColor : buttonColor
    }};
  }

  ${({ buttonColor }) => {
    if (buttonColor) {
      return css`
        background-color: ${buttonColor};
      `
    }
  }};
`
